<div class="flex flex-auto">
	<mat-sidenav-container class="flex flex-auto">
		<mat-sidenav
			[disableClose]="!(this.isMobile$ | async)"
			[mode]="(this.isMobile$ | async) ? 'over' : 'side'"
			[opened]="!(this.isMobile$ | async)"
			#sidenav
			class="shell-main"
		>
			<div
				*ngIf="this.workspace$ | async as ws"
				class="shell-wrapper flex flex-col"
			>
				<mat-toolbar
					*ngIf="!this.isTeams"
					class="header-wrapper mat-toolbar-tg"
				>
					<button
						(click)="officeMenu.toggle()"
						[matRippleColor]="'rgba(255,255,255,.02)'"
						[satPopoverAnchor]="officeMenu"
						class="mat-icon-button-alt mat-icon-fluent"
						mat-icon-button
						matRipple
					>
						<ms-icon icon="WaffleOffice365"></ms-icon>
					</button>
					<div
						[routerLink]="'/'"
						class="header-image flex cursor-pointer flex-row items-center justify-start space-x-2"
					>
						<div class="h-10">
							<mat-icon
								class="header-logo"
								inline
								svgIcon="logo"
							></mat-icon>
						</div>
					</div>
				</mat-toolbar>

				<div class="shell-inner flex flex-auto flex-col">
					@if( (workinghoursEnabled$ | async ) || ( projecthoursEnabled$ | async )) {
					<nav>
						<!-- Timer -->
						@if ((workinghoursEnabled$ | async) || (projecthoursEnabled$ | async)) {
						<mat-list class="my-3 flex flex-col !space-y-2">
							<a
								class="mat-primary shell-list-item route-icon-timer flex flex-row wflex-[1_0_auto]"
								mat-list-item
								matRipple
								routerLink="/timer"
								routerLinkActive="active"
							>
								<div class="route-item">
									<mat-icon svgIcon="ftimer"></mat-icon>
									<span
										class="ml-2"
										translate
										>timer.single</span
									>
								</div>
							</a>
							<ng-container *isDev>
								<a
									class="mat-primary shell-list-item route-icon-timer flex flex-row wflex-[1_0_auto]"
									mat-list-item
									matRipple
									routerLink="/calendar-timer"
									routerLinkActive="active"
								>
									<div class="route-item">
										<mat-icon svgIcon="fcalendar"></mat-icon>
										<span
											class="ml-2"
											translate
										>
											{{ 'Calendar (dev)' }}
										</span>
									</div>
								</a>
							</ng-container>
							<!-- Feed -->
							<a
								*ngIf="projecthoursEnabled$ | async"
								class="mat-primary shell-list-item route-icon-calendar flex flex-row wflex-[1_0_auto]"
								mat-list-item
								matRipple
								routerLink="/feed"
								routerLinkActive="active"
							>
								<div class="route-item">
									<mat-icon svgIcon="fcalendar"></mat-icon>
									<span
										class="ml-2"
										translate
										>feed.name</span
									>
								</div>
							</a>
						</mat-list>
						} @if (((dashboardViewable$.value$ | async).dashboardUrl || (isSupervisor$.value$ | async) ||
						(workspace$canSeeProfitability | async)) && ((workinghoursEnabled$ | async) ||
						(projecthoursEnabled$ | async))) {
						<div
							(click)="toggleInsightsSection()"
							class="mat-subheader shell-section-header select-none text-sm font-bold"
						>
							<span translate>insights.name</span>
							<mat-icon
								[class.--collapsed]="!insightsSectionExpanded"
								class="shell-section-chevron"
							>
								expand_more
							</mat-icon>
						</div>
						<div
							[class.--collapsed]="!insightsSectionExpanded"
							class="shell-section-content"
						>
							<div class="shell-section-content-inner">
								<mat-list class="mb-3 flex flex-col !space-y-2">
									@if (((workinghoursEnabled$ | async) || (projecthoursEnabled$ | async)) &&
									dashboardViewable$.value$ | async; as dashboardViewable) {<!-- Dashboard -->
									<a
										[routerLink]="dashboardViewable.dashboardUrl"
										*ngIf="dashboardViewable.dashboardUrl"
										class="mat-primary shell-list-item route-icon-dashboard flex flex-row wflex-[1_0_auto]"
										mat-list-item
										matRipple
										routerLinkActive="active"
									>
										<div class="route-item">
											<mat-icon svgIcon="fdashboard"></mat-icon>
											<span
												class="ml-2"
												translate
												>dashboard.name</span
											>
										</div>
									</a
									>}<!-- Team-Activity --> @if ((workinghoursEnabled$ | async) ||
									(projecthoursEnabled$ | async)) {
									<a
										*ngIf="ws.permissions.groupsCanSeeTeamActivity || ws.permissions.groupsCanSeeTeamActivityWorkinghours"
										class="mat-primary shell-list-item route-icon-tactivity flex flex-row wflex-[1_0_auto]"
										mat-list-item
										matRipple
										routerLink="/team-activity"
										routerLinkActive="active"
									>
										<div class="route-item">
											<mat-icon svgIcon="factivity"></mat-icon>
											<span
												class="ml-2"
												translate
												>team-activity.name</span
											>
										</div>
									</a>
									}<!-- Insights -->
									<a
										*ngIf="(workspace$canSeeProfitability  | async) && (this.projecthoursEnabled$ | async)"
										class="mat-primary shell-list-item route-icon-insights flex flex-row wflex-[1_0_auto]"
										mat-list-item
										matRipple
										routerLink="/profitability"
										routerLinkActive="active"
									>
										<div class="route-item">
											<mat-icon svgIcon="finsights"></mat-icon>
											<span
												class="ml-2"
												translate
												>insights.profitability</span
											>
										</div>
									</a>
									<!-- Supervisor -->
									@if(supervisorViewable$.value$ | async; as supervisorViewable ) {
									<a
										[routerLink]="supervisorViewable"
										*ngIf="isSupervisor$.value$ | async"
										class="mat-primary shell-list-item route-icon-supervise flex flex-row wflex-[1_0_auto]"
										mat-list-item
										matRipple
										routerLinkActive="active"
									>
										<div class="route-item">
											<mat-icon svgIcon="fsupervisor"></mat-icon>
											<span
												class="ml-2"
												translate
												>supervisor.name</span
											>
										</div>
									</a
									>}
									<a
										*ngIf="!production"
										class="mat-primary shell-list-item route-icon-tactivity flex flex-row wflex-[1_0_auto]"
										mat-list-item
										matRipple
										routerLink="/testing"
										routerLinkActive="active"
									>
										<div class="route-item"><span>Testing Page</span></div>
									</a>
								</mat-list>
							</div>
						</div>
						} @else if (!production) {
						<mat-list class="mb-3 flex flex-col !space-y-2">
							<a
								class="mat-primary shell-list-item route-icon-tactivity flex flex-row wflex-[1_0_auto]"
								mat-list-item
								matRipple
								routerLink="/testing"
								routerLinkActive="active"
							>
								<div class="route-item"><span>Testing Page</span></div>
							</a>
						</mat-list>
						} @if (permissions$.value$ | async; as permissions) { @if (permissions.projecthours &&
						(permissions.groupsCanManageProjects || permissions.groupsCanManageClients ||
						permissions.groupsCanManageTags || permissions.isProjectManager ||
						permissions.groupsCanManageAllProjects || (canSeeProjectsInNavigation$ | async ))) {
						<div
							(click)="toggleManagementSection()"
							class="mat-subheader shell-section-header select-none text-sm font-bold"
						>
							<span translate>workspace.management</span>
							<mat-icon
								[class.--collapsed]="!managementSectionExpanded"
								class="shell-section-chevron"
							>
								expand_more
							</mat-icon>
						</div>
						<div
							[class.--collapsed]="!managementSectionExpanded"
							class="shell-section-content"
						>
							<div class="shell-section-content-inner">
								<mat-list class="flex flex-col !space-y-2">
									@if (permissions.projecthours || permissions.isProjectManager ) {
									<a
										*ngIf="permissions.groupsCanManageProjects || permissions.isProjectManager || permissions.groupsCanManageAllProjects || (canSeeProjectsInNavigation$ | async )"
										class="mat-primary shell-list-item flex flex-row wflex-[1_0_auto]"
										mat-list-item
										matRipple
										routerLink="/settings/projects"
										routerLinkActive="active"
									>
										<div class="route-item">
											<mat-icon>folder</mat-icon>
											<span
												class="ml-2"
												translate
												>project.plural</span
											>
										</div>
									</a>
									<a
										*ngIf="permissions.groupsCanManageClients || (hasRoleControlling$ | async)"
										class="mat-primary shell-list-item flex flex-row wflex-[1_0_auto]"
										mat-list-item
										matRipple
										routerLink="/settings/clients"
										routerLinkActive="active"
									>
										<div class="route-item">
											<mat-icon>account_tree</mat-icon>
											<span
												class="ml-2"
												translate
												>client.plural</span
											>
										</div>
									</a>

									<a
										[teamsHideMobile]="true"
										*ngIf="permissions.groupsCanManageTags || (hasRoleControlling$ | async)"
										class="mat-primary shell-list-item flex flex-row wflex-[1_0_auto]"
										mat-list-item
										matRipple
										routerLink="/settings/tags"
										routerLinkActive="active"
									>
										<div class="route-item">
											<mat-icon>label</mat-icon>
											<span
												class="ml-2"
												translate
												>tag.plural</span
											>
										</div>
									</a>
									}
								</mat-list>
							</div>
						</div>
						} } @if(workspace$admin |async) {
						<div
							(click)="toggleAdminSection()"
							class="mat-subheader shell-section-header select-none text-sm font-bold"
						>
							<span translate>workspace.edit.details</span>
							<mat-icon
								[class.--collapsed]="!adminSectionExpanded"
								class="shell-section-chevron"
							>
								expand_more
							</mat-icon>
						</div>
						<div
							[class.--collapsed]="!adminSectionExpanded"
							class="shell-section-content"
						>
							<div class="shell-section-content-inner">
								<mat-list class="flex flex-col !space-y-2">
									<ng-container *ngIf="this.workspace$admin | async">
										<a
											[class.active]="isWorkspaceSettingsActive()"
											[routerLink]=" (workinghoursEnabled$ | async)  ? '/settings/workspace/workinghours' : (projecthoursEnabled$ | async) ? '/settings/workspace/projecthours' : '/settings/workspace/' "
											class="mat-primary shell-list-item flex flex-row wflex-[1_0_auto]"
											mat-list-item
											matRipple
											teamsHideMobile
										>
											<div class="route-item">
												<mat-icon mat-inline>settings</mat-icon>
												<div
													class="ml-2 flex flex-col"
													translate
												>
													<span>{{ 'workspace.settings' | translate }}</span>
												</div>
											</div>
										</a>
										<a
											[routerLink]="'/settings/workspace/team'"
											[routerLinkActiveOptions]="{ exact: true }"
											class="mat-primary shell-list-item flex flex-row wflex-[1_0_auto]"
											mat-list-item
											matRipple
											routerLinkActive="active"
											teamsHideMobile
										>
											<div class="route-item">
												<mat-icon mat-inline>group</mat-icon>
												<div class="ml-2 flex flex-col">
													<span>{{ 'team._' | translate }}</span>
												</div>
											</div>
										</a>
										<ng-container *ngIf="workspaceStatus$.value$ | async as status">
											<a
												[routerLink]="'/settings/workspace/subscriptions'"
												[routerLinkActiveOptions]="{ exact: true }"
												*ngIf="status.isOwner && !status.isTeamsMobile"
												class="mat-primary shell-list-item flex flex-row wflex-[1_0_auto]"
												mat-list-item
												matRipple
												routerLinkActive="active"
												teams-external
												teamsHideMobile
											>
												<div class="route-item">
													<mat-icon mat-inline>subscriptions</mat-icon>
													<div class="ml-2 flex flex-col">
														<span>{{ 'subscription.single' | translate }}</span>
													</div>
												</div>
											</a>
										</ng-container>
									</ng-container>
									@if (permissions$.value$ | async; as permissions) { @if (permissions.projecthours &&
									ws.me.userIsAdmin) {
									<ng-container *isDev>
										<a
											[routerLinkActiveOptions]="{ exact: true }"
											class="mat-primary shell-list-item flex flex-row wflex-[1_0_auto]"
											mat-list-item
											matRipple
											routerLink="/settings/logs"
											routerLinkActive="active"
										>
											<div class="route-item">
												<mat-icon mat-inline>history</mat-icon>
												<div
													class="ml-2 flex flex-col"
													translate
												>
													<span>{{ 'workspace.logs.title' | translate }}</span>
												</div>
											</div>
										</a>
									</ng-container>
									} }
									<a
										*ngIf="!production"
										class="mat-primary shell-list-item route-icon-flow flex flex-row wflex-[1_0_auto]"
										mat-list-item
										matRipple
										routerLink="/automation"
										routerLinkActive="active"
									>
										<div class="route-item">
											<mat-icon>auto_fix_high</mat-icon>
											<span
												class="ml-2"
												translate
												>automation.name</span
											>
										</div>
									</a>
								</mat-list>
							</div>
						</div>
						} @else {
						<mat-list class="flex flex-col !space-y-2">
							<a
								*ngIf="!production"
								class="mat-primary shell-list-item route-icon-flow flex flex-row wflex-[1_0_auto]"
								mat-list-item
								matRipple
								routerLink="/automation"
								routerLinkActive="active"
							>
								<div class="route-item">
									<mat-icon>auto_fix_high</mat-icon>
									<span
										class="ml-2"
										translate
										>automation.name</span
									>
								</div>
							</a>
						</mat-list>
						}
					</nav>
					<div class="flex-auto"></div>
					<mat-list
						*ngIf="{
					isTrial: this.userSettings.workspace.subscription.status != 'active',
					user: (user$.value$ | async),
					} as wsRef"
						class="mb-3 mt-1.5 flex flex-col space-y-2"
					>
						<a
							[href]="('livedemo-url' | translate) + '?email=' + user.email + '&name=' + (user.officeProfile?.displayName ? user.officeProfile?.displayName : user.email) | safeUrl"
							*ngIf="wsRef.isTrial && wsRef.user as user"
							class="mat-primary shell-list-item flex flex-row wflex-[1_0_auto]"
							mat-list-item
							matRipple
							rel="external noopener nofollow"
							target="_blank"
						>
							<div class="route-item">
								<mat-icon>people_alt</mat-icon>
								<span
									class="ml-2"
									translate
									>livedemo</span
								>
							</div>
						</a>
						<a
							[href]="partnerLink"
							*ngIf="wsRef.user?.links?.partner as partnerLink"
							class="mat-primary shell-list-item flex flex-row wflex-[1_0_auto]"
							mat-list-item
							matRipple
							rel="external noopener nofollow"
							target="_blank"
						>
							<div class="route-item">
								<mat-icon>add_business</mat-icon>
								<span
									class="ml-2"
									translate
									>partners.request</span
								>
							</div>
						</a>
					</mat-list>
					}
					<div class="mat-bg-3 mx-2 flex flex-col rounded mt-auto">
						<div class="ml-2">
							<button
								(click)="openWidget()"
								[disabled]="widgetLoading"
								class="mat-icon-button mat-icon-button-flex !h-10 !w-auto !justify-start"
								mat-icon-button
								matTooltip="Support"
							>
								<span class="flex items-center whitespace-nowrap">
									<span class="inline-flex size-6 flex-shrink-0 items-center justify-center">
										@if (!widgetLoading) {
										<mat-icon>live_help</mat-icon>
										} @else {
										<mat-progress-spinner
											[diameter]="18"
											[strokeWidth]="2"
											mode="indeterminate"
										></mat-progress-spinner>
										}
									</span>
									<span class="ml-[6px]"> {{ 'contactSupport' | translate }}</span>
								</span>
							</button>
						</div>
					</div>

					<div class="pb-2"></div>
					<div class="flex flex-col">
						<div class="flex flex-col space-y-2">
							<div
								(click)="openWorkspaceDialog()"
								class="line-height-base mat-bg-2-hover mx-2 mb-2 flex min-w-0 cursor-pointer select-none flex-row items-center justify-start gap-2 rounded px-4 py-3"
							>
								<mat-icon
									class="mat-bg-5 flex-shrink-0 rounded-circle -ml-2 p-2 text-lg"
									inline
								>
									work
								</mat-icon>
								<div class="flex min-w-0 flex-1 flex-col overflow-hidden">
									<span
										class="text-sm"
										translate
										>workspace.single</span
									>
									<div class="truncate text-sm font-bold">{{ ws.name }}</div>
								</div>
								<mat-icon
									class="mat-bg-5 -mr-1 flex-shrink-0 !rounded-xl text-lg !leading-normal"
									inline
								>
									unfold_more
								</mat-icon>
							</div>
						</div>
						<ng-container *ngIf="workspaceStatus$.value$ | async as status">
							<ng-container *ngIf="showUser$ | async">
								<mat-divider inset></mat-divider>
								<div class="mt-2 flex items-center space-x-2 pr-2 overflow-hidden">
									<div
										(click)="userMenuRef.menuTrigger.toggleMenu()"
										class="mat-bg-2-hover mx-2 mb-2 flex flex-auto cursor-pointer select-none flex-row items-center justify-start gap-[10px] truncate rounded px-4 py-2"
									>
										<app-user-menu
											(click)="$event.stopPropagation(); $event.preventDefault()"
											[closeOnNavigation]="true"
											[disableMenu]="true"
											#userMenuRef
											class="-ml-2"
											size="30px"
										></app-user-menu>
										<div class="flex flex-col truncate flex-auto">
											<span class="mat-typography -mr-2 truncate text-sm">{{
												this.currentUser.officeProfile.displayName | parseName
											}}</span>
										</div>
										<mat-icon
											class="mat-bg-5 -mr-1 flex-shrink-0 !rounded-xl text-lg !leading-normal"
											inline
										>
											expand_less
										</mat-icon>
									</div>
									<tg-frill-button></tg-frill-button>
								</div>
							</ng-container>
							<div
								class="flex flex-col space-y-2"
								teams-hide
								teamsHideMobile
							>
								<ng-container *ngIf="status.isTrial; else nonTrialExpired">
									<div
										(click)="!status.isTeamsMobile && this.openWorkspacePlan()"
										[class.cursor-pointer]="!status.isTeamsMobile"
										[send-tagmanager_event]="{
							category: 'purchase_c2a',
							action: 'upgrade button sidebar',
							}"
										*ngIf="!status.isTeamsMobile"
										class="flex flex-col justify-center"
									>
										<ng-container *ngIf="!status.isExpired; else nonTrialExpired">
											<div
												*ngIf="status.endDate as end"
												class="alert alert-primary text-sm"
											>
												Trial, {{ end | dfnsFormatDistanceToNow }}
											</div>
										</ng-container>
									</div>
								</ng-container>
								<ng-template #nonTrialExpired>
									<tg-subscription-status-row [navigateOnClick]="true"></tg-subscription-status-row>
								</ng-template>
							</div>
						</ng-container>
					</div>
				</div>
			</div>
		</mat-sidenav>
		<mat-sidenav-content
			#container
			class="flex flex-auto"
		>
			<div
				class="router-wrapper"
				id="wrapper"
			>
				<router-outlet #o="outlet"></router-outlet>
				<app-loader
					[enableCircle]="true"
					[isActive]="this.isLoading !== false"
					#routerLoader
				></app-loader>

				<ng-container *ngIf="isMobileWidgets$ | async">
					<ng-container
						*ngTemplateOutlet="(view$ | async) === 'work' && (workinghoursEnabled$ | async) ? RecordComegoWidget : RecordProjectWidget"
					></ng-container>
				</ng-container>

				<ng-container *ngIf="!(isMobileWidgets$ | async)">
					<ng-container
						*ngTemplateOutlet="
              this.userSettings.settings.widgetPreference === 'noWidget'
                ? null
                : this.userSettings.settings.widgetPreference === 'sameWidget'
                  ? (view$ | async) === 'work'
                    ? (workinghoursEnabled$ | async)
                      ? RecordComegoWidget
                      : RecordProjectWidget
                    : RecordProjectWidget
                  : (view$ | async) === 'work'
                    ? !(projecthoursEnabled$ | async)
                      ? RecordComegoWidget
                      : RecordProjectWidget
                    : (workinghoursEnabled$ | async)
                      ? RecordComegoWidget
                      : RecordProjectWidget
            "
					></ng-container>
				</ng-container>
			</div>
		</mat-sidenav-content>
	</mat-sidenav-container>
</div>
<ng-template #RecordProjectWidget> <tg-record-widget></tg-record-widget> </ng-template>
<ng-template #RecordComegoWidget> <tg-record-comego-widget></tg-record-comego-widget> </ng-template>
<sat-popover
	#officeMenu
	class="popover-menu-top-left-offset"
	hasBackdrop
>
	<mat-card class="ms-office-menu ms-office-menu-offset">
		<div class="flex flex-col space-y-2">
			<div class="popover-card-header">
				<div class="flex flex-row items-center justify-start space-x-2 p-2">
					<button
						(click)="officeMenu.close()"
						class="mat-icon-button-alt mat-icon-fluent"
						mat-icon-button
					>
						<ms-icon
							class="mat-typography"
							icon="WaffleOffice365"
						></ms-icon>
					</button>
					<div class="!ml-auto mr-1 flex flex-row items-center justify-start">
						<a
							href="https://www.office.com"
							mat-link
							referrerpolicy="origin"
							target="_blank"
						>
							<div class="flex flex-row items-center justify-start gap-[4px]">
								<small>Microsoft 365</small>
								<mat-icon inline>arrow_forward</mat-icon>
							</div>
						</a>
					</div>
				</div>
			</div>
			<h4 class="mt-0">Apps</h4>
			<div class="ms-office-menu-list flex flex-col gap-[4px] p-1">
				<div class="flex flex-row items-center justify-start space-x-2">
					<button
						(click)="openLink('https://www.office.com/launch/word')"
						class="ms-office-menu-item text-left"
						mat-button
					>
						<div class="flex flex-row items-center justify-start gap-[4px]">
							<mat-icon
								class="ms-Icon"
								svgIcon="ms_word"
							></mat-icon>
							<span>Word</span>
						</div>
					</button>
					<button
						(click)="openLink('https://www.office.com/launch/powerpoint')"
						class="ms-office-menu-item text-left"
						mat-button
					>
						<div class="flex flex-row items-center justify-start gap-[4px]">
							<mat-icon
								class="ms-Icon"
								svgIcon="ms_powerpoint"
							></mat-icon>
							<span>Power Point</span>
						</div>
					</button>
				</div>
				<div class="flex flex-row items-center justify-start space-x-2">
					<button
						(click)="openLink('https://outlook.office.com/owa/?modurl=0')"
						class="ms-office-menu-item text-left"
						mat-button
					>
						<div class="flex flex-row items-center justify-start gap-[4px]">
							<mat-icon
								class="ms-Icon"
								svgIcon="ms_outlook"
							></mat-icon>
							<span>Outlook</span>
						</div>
					</button>
					<button
						(click)="openLink('https://aka.ms/mstfw')"
						class="ms-office-menu-item text-left"
						mat-button
					>
						<div class="flex flex-row items-center justify-start gap-[4px]">
							<mat-icon
								class="ms-Icon"
								svgIcon="ms_teams"
							></mat-icon>
							<span>Teams</span>
						</div>
					</button>
				</div>
				<div class="flex flex-row items-center justify-start space-x-2">
					<button
						(click)="openLink('https://www.microsoft.com/microsoft-365/onedrive/onedrive-for-business')"
						class="ms-office-menu-item text-left"
						mat-button
					>
						<div class="flex flex-row items-center justify-start gap-[4px]">
							<mat-icon
								class="ms-Icon"
								svgIcon="ms_onedrive"
							></mat-icon>
							<span>OneDrive</span>
						</div>
					</button>
					<button
						(click)="openLink('https://to-do.office.com/tasks')"
						class="ms-office-menu-item text-left"
						mat-button
					>
						<div class="flex flex-row items-center justify-start gap-[4px]">
							<mat-icon
								class="ms-Icon"
								svgIcon="ms_todo"
							></mat-icon>
							<span>To Do</span>
						</div>
					</button>
				</div>
				<div class="ms-office-menu-footer flex flex-row items-center justify-center">
					<a
						class="mat-hint py-1"
						href="https://timeghost-solutions.com/"
						mat-link
						target="_blank"
					>
						<small>timeghost-solutions.com</small>
					</a>
				</div>
			</div>
		</div>
	</mat-card>
</sat-popover>
<ng-template
	#showTimer
	let-item
>
	<span class="ml-2">
		<tg-record-toolbar-counter [start]="item.time.start | dfnsParseIso"></tg-record-toolbar-counter>
	</span>
</ng-template>
<ng-template #showTimerText>
	<span
		class="ml-2"
		translate
		>timer.single</span
	>
</ng-template>
